<template>
  <div>
    <div class="has-background-white" style="padding: 0.5em;">
      <div style="text-align: right;">
        <b-tooltip label="過去のいいねをまとめて取得できます"
            position="is-left" always :active="tooltipActive">
          <b-icon icon="heart" style="margin-left:1em;"
                  @click.native="$router.push('/like_log')">
          </b-icon>
        </b-tooltip>
        <b-icon icon="retweet" style="margin-left:1em;"
                @click.native="$router.push('/retweet')">
        </b-icon>
      </div>
      <p class="is-size-4 has-text-grey-dark">最近いいねしたツイート</p>
    </div>
    <div class="has-text-centered userhome">
      <b-field position="is-centered" grouped>
        <b-switch v-model="is_rt_threshold" type="is-danger">10RT以上</b-switch>
        <b-switch v-model="is_not_categorized" type="is-danger">未分類のみ</b-switch>
      </b-field>
    </div>
    <b-message 
      title="お知らせ" 
      type="is-danger" 
      aria-close-label="Close message">
      TwitterのAPI仕様変更により、「いいね」が取得できなくなってしまいました。そのため、現在いいねしたツイートは読み込めません。
    </b-message>
    <div  class="columns is-gapless is-multiline is-desktop">
      <div v-for="tweet in fav_tweets_show" :key="tweet.id"  class="column is-4-desktop">
        <TweetBox :tweet_info="tweet" @tweet-regist="changeRegistState(tweet.id)"/>
      </div>
    </div>
    <div class="button is-fullwidth" @click="next_fav_page()">
      <b-icon icon="angle-double-down"></b-icon>
    </div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import TweetBox from '@/components/TweetBox.vue'
const axios = require('axios')

export default {
  title: "- いいねしたツイート",
  components: {
    TweetBox
  },
  data() {
    return {
      fav_tweets: [],
      is_rt_threshold: true,
      is_not_categorized: true,
      isLoading: true,
      tooltipActive: true,
    }
  },
  methods: {
    fetch_fav_list() {
      const api_url = "https://asia-northeast1-interimadd-twitter-api.cloudfunctions.net/get_fav_list"
      const user_info = this.$store.getters['getUserInfo']
      axios.get(api_url, {
        params: {
          count: 50,  // 何個分ツイートを取得するか
          at: user_info.access_token,
          ats: user_info.access_token_secret,
          max_id: this.max_tweet_id,
        }
      })
      .then(res => {
        if(res.data.length > 0){
          this.fav_tweets = res.data.map((tweet)=>{
            tweet.registeredListname = this.$store.getters.findRegistedList(tweet.id)
            return tweet
          })
        }
        this.isLoading = false
      })
      .catch(err => {throw new Error(err)})
    },
    next_fav_page() {
      if(this.fav_tweets.length == 0){return}
      const last_tweet_id = this.fav_tweets[this.fav_tweets.length-1].id
      window.scrollTo({top: 100})
      this.isLoading = true
      this.$router.push({path:'/user', query: { id: last_tweet_id } }).catch(()=>{})
    },
    changeRegistState(tweet_id) {
      for(let idx in this.fav_tweets){
        if(this.fav_tweets[idx].id == tweet_id){
          this.fav_tweets[idx].registeredListname = this.$store.getters.findRegistedList(tweet_id)
          return
        }
      }
    },
  },
  created(){
    if(localStorage.is_rt_threshold != undefined){
      this.is_rt_threshold = Boolean(Number(localStorage.is_rt_threshold))
    }
    if(localStorage.is_not_categorized != undefined){
      this.is_not_categorized = Boolean(Number(localStorage.is_not_categorized))
    }
    setTimeout(function() {
      this.tooltipActive = false
    }.bind(this), 5000)
  },
  mounted() {
    this.fetch_fav_list()
  },
  watch: {
    is_rt_threshold(val) {
      localStorage.is_rt_threshold = val ? 1 : 0
    },
    is_not_categorized(val) {
      localStorage.is_not_categorized = val ? 1 : 0
    },
    max_tweet_id() {
      this.fetch_fav_list()
    }
  },
  computed: {
    min_rt_num() {
      return this.is_rt_threshold ? 10 : 0
    },
    max_tweet_id() {
      if(this.$route.query.id == undefined){return ""}
      return this.$route.query.id
    },
    fav_tweets_show() {
      if(this.fav_tweets.length == 0 || this.fav_tweets.length == undefined) return []
      const fav_thr_tweets = this.fav_tweets.filter(tweet => tweet.retweet_count >= this.min_rt_num)
      if(this.is_not_categorized){
        return fav_thr_tweets.filter(tweet => tweet.registeredListname == "")
      }
      else{
        return fav_thr_tweets
      }
    },
  }
}
</script>

<style>
.userhome {
  margin-bottom: 1em;
}
</style>